import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AppUserState } from '../../stores/states/app.state';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss']
})
export class ProfileImageComponent implements OnInit, OnChanges {
  defaultColor = '#6B7280';

  @Input() member!: AppUserState | null;
  @Input() config: any = {
    size: 'w-8 h-8 text-sm'
  };
  @Input() avatarBgColor?: string;



  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.assignColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['member']) {
      this.assignColor();
      this.cdr.detectChanges();
    }
  }

  static getAvatarColor(member: AppUserState | null, defaultColor: string = '#6B7280'): string {
    if (!member) {
      return defaultColor;
    }


    if (member.settings?.avatarBgColor) {
      return member.settings.avatarBgColor;
    }


    return defaultColor;
  }

  assignColor(): void {
    this.cdr.detectChanges();
  }

  getRandomHexColor(): string {
    return this.defaultColor;
  }

  getInitials(name: string): string {
    return name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : '';
  }
}
